import DonationReportModal from '@/core/components/DonationReportModal/DonationReportModal';

export default DonationReportModal;
